<template>
  <div>
    <!--header-->
    <header class="header">
      <div class="header__inner type_02">
        <div class="header__btns">
          <button class="header__btns prev" @click="fnClose()"></button>
        </div>
        <h1 class="header__ttl">{{ data.title }}</h1>
        <div class="header__btns"></div>
      </div>
    </header>
    <!--main-->
    <main class="main" role="main">
      <div class="main__inner"><!-- 배경: bg-->
        <div class="main__con">
          <div class="sign__page">
            <vue-daum-postcode
              style="height: 100%;"
              :animation="false"
              :no-shorthand="false"
              :no-autoMapping="false"
              v-on:complete="fnSelectAddress($event)"
              v-if="isShow"
            />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script type="text/javascript" src="http://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"></script>
<script>
import {VueDaumPostcode} from 'vue-daum-postcode'
export default {
  components: {VueDaumPostcode},
  name: 'address-modal',
  props: {
    data: {
      type: [Array, Object],
      default: () => {
      }
    },
    callBack: {
      type: [Function]
    }
  },
  data: function () {
    return {
      isShow: false
    }
  },
  created: function () {
    setTimeout(() => {
      this.isShow = true
    }, 1000)
  },
  methods: {
    fnClose: function () {
      this.$emit('eventClose')
    },
    fnSelectAddress: function (item) {
      if (this.callBack !== undefined && this.callBack !== null) {
        this.callBack(item)
        this.$emit('eventClose', -2)
      }
    }
  }
}
</script>

<style scoped>
/*.modalPage {*/
/*  position: fixed;*/
/*  transition-property: top;*/
/*  transition-duration: 0.5s;*/
/*  transition-delay: 0s;*/
/*  top: 100vh;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  z-index: 100;*/
/*}*/

/*.modalPage.on {*/
/*  transition-property: top;*/
/*  transition-duration: 0.5s;*/
/*  transition-delay: 0s;*/
/*  top: 0;*/
/*}*/
</style>
